import MainLoader from "../../animation/MainLoader";
import ErrorMessageAnimationModal from "../../animation/ErrorMessageAnimationModal";
import SuccessMessageAnimationModal from "../../animation/SuccessMessageAnimationModal";

import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import Breadcrumb from "../common/breadcrumb";
import {
  getImageUrl,
  getPlaceHolderImage,
  getSettingUrl,
  getShippingOptionsUrl,
  getMerchantInformationUrl,
  getPincodeDeliveryUrl,
  getMasterDetailsIdUrl,
  getServiceChargesUrl,
} from "../../services";
import {
  loadUserDetailsFromLocalStorage,
  removeCurrentLanguage,
  getValueFromLanguageObject,
  getCurrencySymbol,
  getOpenStoreIdApp,
  formatPrice,
} from "../../store";
import { getCall, patchCall } from "../../api/post";
import {
  getCommonCounter,
  getNotificationCounter,
  getUpdateQuantity,
  isInquiryOrCart,
  setHeaderCounters
} from "../../actions";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import DeleteAnim from "../../animation/AnimFiles/DeleteAnim";
import NoProductFoundCartAnim from "../../animation/AnimFiles/NoProductFoundCartAnim";
import ConfirmAlertPopup from "../../Alert/ConfirmAlertPopup";
import {
  clearLocalStorageReload,
  isOpenStoreIdExist,
  navigateTo,
  removeUserDetailAndOtherDetails,
} from "../../utils/utils";
import Lightbox from "react-image-lightbox";

class cartComponent extends Component {
  state = {
    cartList: [],
    orderDetails: [],
    isLoading: true,
    isMerchantGSTEnable: false,
    merchantInfo: {},
    shippingCharges: [],
    AppTitle: "",
    isPincodeDeliveryEnable: false,
    currentCatelogueType: {},
    showErrorMessageModal: false,
    errorMessage: "",
    showSuccessMessageModal: false,
    successMessage: "",
    masterDetailsObj: {},
    isFullScreenImage: false,
    fullScreenImagePath: "",
    updatedQty: "",
    serviceCharges: {},
    outOfStockProductIds: [], // <--- NEW
  };
  constructor(props) {
    super(props);
  // Authentication/redirection moved to central route guard (PrivateRoute).
  }

  removeUserDetailAndRedirectToLogin = () => {
    removeUserDetailAndOtherDetails();
    removeCurrentLanguage();
    navigateTo(this.props, `/login`);
  };

  componentDidMount() {
    this.initMasterDetailsId().then(() => {
      const { masterDetailsObj } = this.state;
      this.initCartList().then(() => {
        this.setState({ isLoading: false });
      });
      this.initMerchantInfo();
      this.initCatelogueSettings();
      this.initShippingCharges();
      this.initServiceCharges();
      this.initPincodeDelivery();
      this.props.notificationCounter();
      this.props.isInquiryOrCart(masterDetailsObj);
    });
  }

  initMasterDetailsId = async () => {
    let masterDetailsObj = {};
    const publicUrl = window.location.pathname.split("/")[1];
    const masterDetailsIdUrl = getMasterDetailsIdUrl(publicUrl);
    const masterDetails = await getCall(masterDetailsIdUrl, []).then();
    if (masterDetails.error) {
      clearLocalStorageReload({ response: masterDetails });
    } else {
      if (masterDetails) {
        masterDetailsObj = masterDetails;
      }
    }
    this.setState({ masterDetailsObj: masterDetailsObj });
  };

  initCartList = async () => {
    let userDetails = loadUserDetailsFromLocalStorage();
    if (!isOpenStoreIdExist() && userDetails === undefined) {
      return;
    } else {
      userDetails = userDetails === undefined ? {} : userDetails;
    }
    const { id } = userDetails;
    const openStoreId = getOpenStoreIdApp();
    let userId = openStoreId ? openStoreId : id;
    const cartListUrl = `orders?filter[where][userId]=${userId}&filter[where][inshoppingcart]=1&filter[order]=created`;
    const cartList = await getCall(cartListUrl, []);
    if (cartList.error) {
      clearLocalStorageReload({ response: cartList });
      this.loadErrorMessageAnimation(cartList.error.message);
      if (cartList.error.statusCode && cartList.error.statusCode === 401) {
        this.removeUserDetailAndRedirectToLogin();
        return;
      }
    } else {
      this.setState({ cartList });
      
      // Combine all orderdetails from all cart items
      let allOrderDetails = [];
      if (cartList && Array.isArray(cartList) && cartList.length > 0) {
        cartList.forEach(cartItem => {
          if (cartItem && cartItem.orderdetails && Array.isArray(cartItem.orderdetails)) {
            allOrderDetails = allOrderDetails.concat(cartItem.orderdetails);
          }
        });
      }
      
      // NEW: compute out-of-stock product ids
      const outOfStockProductIds = allOrderDetails
        .filter(od => this.isProductOutOfStock(od))
        .map(od => od.id);

      const inactiveProductIds = allOrderDetails
  .filter(od => this.isProductInactive(od))
  .map(od => od.id);

this.setState({ orderDetails: allOrderDetails, outOfStockProductIds, inactiveProductIds });
    }
  };

  fetchHeaderCounters = async () => {
  try {
    const response = await getCall("v2/dashboard/header-counters", []);
    if (response.error) {
      return;
    }
    this.props.setHeaderCounters(response); // <-- dispatch to Redux
  } catch (e) {}
};

  initShippingCharges = async () => {
    const { masterDetailsObj } = this.state;
    const shippingChargesUrl = getShippingOptionsUrl(masterDetailsObj);
    const shippingCharges = await getCall(shippingChargesUrl, []);
    if (shippingCharges.error) {
      clearLocalStorageReload({ response: shippingCharges });
    }
    this.setState({ shippingCharges: shippingCharges });
  };

  initServiceCharges = async () => {
    const { masterDetailsObj } = this.state;
    const serviceChargesUrl = getServiceChargesUrl(masterDetailsObj);
    const serviceChargesResponse = await getCall(serviceChargesUrl, []);

    const { error } = serviceChargesResponse || {};
    if (error) {
      clearLocalStorageReload({ response: serviceChargesResponse });
    }
    const [serviceCharges] = serviceChargesResponse || {};
    this.setState({ serviceCharges: serviceCharges });
  };

  minusQty = (orderDetail, index) => {
    if (this.isProductOutOfStock(orderDetail)) return; // NEW guard
    const { isInquiry } = this.props;

    this.setState({ isLoading: true }, () => {
      if (isInquiry) {
        this.editInquiryApi(orderDetail, index, 0).then(() => {
          this.setState({ isLoading: false });
        });
      } else {
        this.editCartApi(orderDetail, index, 0).then(() => {
          this.setState({ isLoading: false });
        });
      }
    });
  };

  plusQty = (orderDetail, index) => {
    if (this.isProductOutOfStock(orderDetail)) return; // NEW guard

    // Prevent increasing beyond available quantity
    const available = this.getAvailableQuantity(orderDetail);
    if (orderDetail.quantity >= available) return; // <-- This line ensures no increase beyond available

    const { isInquiry } = this.props;
    this.setState({ isLoading: true }, () => {
      if (isInquiry) {
        this.editInquiryApi(orderDetail, index, 1).then(() => {
          this.setState({ isLoading: false });
        });
      } else {
        this.editCartApi(orderDetail, index, 1).then(() => {
          this.setState({ isLoading: false });
        });
      }
    });
  };

  // Helper to get available quantity
  getAvailableQuantity = (orderDetail) => {
    if (!orderDetail || !orderDetail.products) return 0;
    const p = orderDetail.products;
    const candidates = [
      p.availablequantity,
      p.availableQuantity,
      p.quantityavailable,
      p.stock,
      p.quantity,
    ];
    let available = undefined;
    for (let i = 0; i < candidates.length; i++) {
      const v = candidates[i];
      if (v !== undefined && v !== null) {
        available = v;
        break;
      }
    }
    return Number(available) || 0;
  };

  editInquiryApi = async (orderDetail, index, operation) => {
    const { orderDetails, cartList } = this.state;
    let userDetails = loadUserDetailsFromLocalStorage();
    if (!isOpenStoreIdExist() && userDetails === undefined) {
      return;
    } else {
      userDetails = userDetails === undefined ? {} : userDetails;
    }
    const { id } = userDetails;
    const openStoreId = getOpenStoreIdApp();
    let userId = openStoreId ? openStoreId : id;

    const tempQty =
      operation === 0 ? orderDetail.quantity - 1 : orderDetail.quantity + 1;
    if (orderDetail.products.minimumorderquantity > tempQty) {
      return;
    }
    if (tempQty === 0) {
      return;
    }

    // Find the cart item that contains this order detail
    let targetCartItem = null;
    if (cartList && Array.isArray(cartList) && cartList.length > 0) {
      for (let i = 0; i < cartList.length; i++) {
        const cartItem = cartList[i];
        if (cartItem && cartItem.orderdetails && Array.isArray(cartItem.orderdetails)) {
          const foundIndex = cartItem.orderdetails.findIndex(od => od.id === orderDetail.id);
          if (foundIndex !== -1) {
            targetCartItem = cartItem;
            break;
          }
        }
      }
    }
    
    if (!targetCartItem || !targetCartItem.id) {
      this.loadErrorMessageAnimation("Cart item not found");
      return;
    }

    const orderId = targetCartItem.id;
    const editInquiryUrl = `orders/${orderId}?filter[orderedit]=true`;
    const editInquiryObj = {
      userId,
      inshoppingcart: 1,
      orderdetails: [
        {
          id: orderDetail.id,
          quantity: tempQty,
        },
      ],
    };
    const editInquiry = await patchCall(editInquiryUrl, editInquiryObj);
    if (editInquiry.error) {
      clearLocalStorageReload({ response: editInquiry });
      this.loadErrorMessageAnimation(editInquiry.error.message);
      if (
        editInquiry &&
        editInquiry.error &&
        editInquiry.error.statusCode &&
        editInquiry.error.statusCode === 401
      ) {
        this.removeUserDetailAndRedirectToLogin();
        return;
      }
    } else {
      const tempOrderDetail = orderDetails;
      tempOrderDetail[index].quantity = tempQty;
      this.setState({ orderDetails: tempOrderDetail });

      this.loadSuccessMessageAnimation(
        getValueFromLanguageObject("msg_your_inquiry_updated_successfully")
          ? getValueFromLanguageObject("msg_your_inquiry_updated_successfully")
          : "Your inquiry updated successfully"
      );
    }
  };

  editCartApi = async (orderDetail, index, operation) => {
    const {
      orderDetails,
      merchantInfo,
      isMerchantGSTEnable,
      currentCatelogueType,
    } = this.state;
    const { isInquiry } = this.props;
    // operation == 0 --- Decrese Qty
    // operation == 1 --- Increase Qty
    const { cartList } = this.state;
    let userDetails = loadUserDetailsFromLocalStorage();
    if (!isOpenStoreIdExist() && userDetails === undefined) {
      return;
    } else {
      userDetails = userDetails === undefined ? {} : userDetails;
    }
    const { id } = userDetails;
    const openStoreId = getOpenStoreIdApp();
    let userId = openStoreId ? openStoreId : id;

    const total = this.getTotalofCart(cartList);
    const tempQty =
      operation === 0 ? orderDetail.quantity - 1 : orderDetail.quantity + 1;

    if (orderDetail.products.minimumorderquantity > tempQty) {
      return;
    }
    if (tempQty === 0) {
      return;
    }
    const tempAmount = orderDetail.amount;
    
    // Find the cart item that contains this order detail
    let targetCartItem = null;
    if (cartList && Array.isArray(cartList) && cartList.length > 0) {
      for (let i = 0; i < cartList.length; i++) {
        const cartItem = cartList[i];
        if (cartItem && cartItem.orderdetails && Array.isArray(cartItem.orderdetails)) {
          const foundIndex = cartItem.orderdetails.findIndex(od => od.id === orderDetail.id);
          if (foundIndex !== -1) {
            targetCartItem = cartItem;
            break;
          }
        }
      }
    }
    
    if (!targetCartItem || !targetCartItem.id) {
      this.loadErrorMessageAnimation("Cart item not found");
      return;
    }
    
    const orderId = targetCartItem.id;
    const editCartUrl = "orders/" + orderId;
    var editCartObj = {};
    const subTotal = this.getSubTotalFromTotalandServiceCharges();
    if (
      isMerchantGSTEnable &&
      currentCatelogueType &&
      currentCatelogueType.registerallow !== "Catalogue_Jewellary"
    ) {
      editCartObj = {
        totalamount:
          operation === 0
            ? this.getGrandTotal(
                subTotal - tempAmount,
                this.getCGSTFromTotal(subTotal - tempAmount),
                this.getSGSTFromTotal(subTotal - tempAmount),
                this.getIGSTFromTotal(subTotal - tempAmount),
                this.getShippingCharges(subTotal - tempAmount)
              )
            : this.getGrandTotal(
                subTotal + tempAmount,
                this.getCGSTFromTotal(subTotal + tempAmount),
                this.getSGSTFromTotal(subTotal + tempAmount),
                this.getIGSTFromTotal(subTotal + tempAmount),
                this.getShippingCharges(subTotal + tempAmount)
              ),
        userId,
        inshoppingcart: 1,
        orderdetails: [
          {
            id: orderDetail.id,
            quantity: tempQty,
          },
        ],
        tax: {
          cgst: merchantInfo.CGST,
          sgst: merchantInfo.SGST,
          cgstPrice:
            operation === 0
              ? this.getCGSTFromTotal(subTotal - tempAmount)
              : this.getCGSTFromTotal(subTotal + tempAmount),
          sgstPrice:
            operation === 0
              ? this.getSGSTFromTotal(subTotal - tempAmount)
              : this.getSGSTFromTotal(subTotal + tempAmount),
        },
        baseprice:
          operation === 0 ? subTotal - tempAmount : subTotal + tempAmount,
        shippingprice:
          operation === 0
            ? this.getShippingCharges(subTotal - tempAmount)
            : this.getShippingCharges(subTotal + tempAmount),
      };
    } else if (
      isMerchantGSTEnable &&
      currentCatelogueType &&
      currentCatelogueType.registerallow === "Catalogue_Jewellary"
    ) {
      editCartObj = {
        totalamount:
          operation === 0
            ? this.getGrandTotal(
                subTotal - tempAmount,
                this.getCGSTFromTotal(subTotal - tempAmount),
                this.getSGSTFromTotal(subTotal - tempAmount),
                this.getIGSTFromTotal(subTotal - tempAmount),
                this.getShippingCharges(subTotal - tempAmount)
              )
            : this.getGrandTotal(
                subTotal + tempAmount,
                this.getCGSTFromTotal(subTotal + tempAmount),
                this.getSGSTFromTotal(subTotal + tempAmount),
                this.getIGSTFromTotal(subTotal + tempAmount),
                this.getShippingCharges(subTotal + tempAmount)
              ),
        userId,
        inshoppingcart: 1,
        orderdetails: [
          {
            id: orderDetail.id,
            quantity: tempQty,
          },
        ],
        baseprice:
          operation === 0 ? subTotal - tempAmount : subTotal + tempAmount,
        shippingprice:
          operation === 0
            ? this.getShippingCharges(subTotal - tempAmount)
            : this.getShippingCharges(subTotal + tempAmount),
      };
    } else {
      editCartObj = {
        totalamount:
          operation === 0
            ? total -
              tempAmount -
              this.getShippingCharges(subTotal - tempAmount)
            : total +
              tempAmount +
              this.getShippingCharges(subTotal + tempAmount),
        userId,
        inshoppingcart: 1,
        orderdetails: [
          {
            id: orderDetail.id,
            quantity: tempQty,
          },
        ],
        shippingprice:
          operation === 0
            ? this.getShippingCharges(subTotal - tempAmount)
            : this.getShippingCharges(subTotal + tempAmount),
      };
    }

    const editOrder = await patchCall(editCartUrl, editCartObj);
    if (editOrder.error) {
      clearLocalStorageReload({ response: editOrder });
      this.loadErrorMessageAnimation(editOrder.error.message);
      if (
        cartList &&
        cartList.error &&
        cartList.error.statusCode &&
        cartList.error.statusCode === 401
      ) {
        this.removeUserDetailAndRedirectToLogin();
        return;
      }
    } else {
      const tempOrderDetail = orderDetails;
      tempOrderDetail[index].quantity = tempQty;
      this.setState({ orderDetails: tempOrderDetail });
      if (isInquiry) {
        this.loadSuccessMessageAnimation(
          getValueFromLanguageObject("msg_your_inquiry_updated_successfully")
            ? getValueFromLanguageObject(
                "msg_your_inquiry_updated_successfully"
              )
            : "Your inquiry updated successfully"
        );
      } else {
        this.loadSuccessMessageAnimation(
          getValueFromLanguageObject("msg_your_order_updated_successfully")
            ? getValueFromLanguageObject("msg_your_order_updated_successfully")
            : "Your order updated successfully"
        );
      }
      
      // Add a small delay to ensure backend has finished processing the update
      setTimeout(async () => {
        await this.props.counter();
        await this.fetchHeaderCounters(); // <-- add this
      }, 500);
      
      this.setState({ isLoading: true });
      this.initCartList().then(() => {
        this.setState({ isLoading: false });
      });
    }
  };

  changeQty = (index, e) => {
    const { orderDetails } = this.state;
    const od = orderDetails[index];
    if (this.isProductOutOfStock(od)) return; // NEW guard
    let qty = e.target.value;

    // Prevent entering more than available quantity
    const available = this.getAvailableQuantity(od);
    if (qty !== "" && isFinite(qty)) {
      if (Number(qty) > available) qty = available;
      this.setState({ updatedQty: qty });
      const tempOrderDetail = [...orderDetails];
      tempOrderDetail[index].quantity = parseInt(qty);
      this.setState({ orderDetails: tempOrderDetail });
    } else {
      const tempOrderDetail = [...orderDetails];
      tempOrderDetail[index].quantity = "";
      this.setState({ orderDetails: tempOrderDetail });
    }
  };

  updateCartAPI = async (orderDetail, index) => {  // added async
    if (this.isProductOutOfStock(orderDetail)) return; // NEW guard
    const {
      isMerchantGSTEnable,
      merchantInfo,
      currentCatelogueType,
    } = this.state;
    const { isInquiry } = this.props;
    const { cartList, updatedQty } = this.state;
    let userDetails = loadUserDetailsFromLocalStorage();
    if (!isOpenStoreIdExist() && userDetails === undefined) {
      return;
    } else {
      userDetails = userDetails === undefined ? {} : userDetails;
    }
    const { id } = userDetails;
    const openStoreId = getOpenStoreIdApp();
    let userId = openStoreId ? openStoreId : id;

    const tempQty = updatedQty;
    if (orderDetail.products.minimumorderquantity > tempQty) {
      return;
    }
    if (tempQty === 0) {
      return;
    }
    
    // Find the cart item that contains this order detail
    let targetCartItem = null;
    if (cartList && Array.isArray(cartList) && cartList.length > 0) {
      for (let i = 0; i < cartList.length; i++) {
        const cartItem = cartList[i];
        if (cartItem && cartItem.orderdetails && Array.isArray(cartItem.orderdetails)) {
          const foundIndex = cartItem.orderdetails.findIndex(od => od.id === orderDetail.id);
          if (foundIndex !== -1) {
            targetCartItem = cartItem;
            break;
          }
        }
      }
    }
    
    if (!targetCartItem || !targetCartItem.id) {
      this.loadErrorMessageAnimation("Cart item not found");
      return;
    }
    
    const orderId = targetCartItem.id;
    const editCartUrl = "orders/" + orderId;
    const subTotal = this.getSubTotalFromTotalandServiceCharges();
    const totalAmount = this.getGrandTotal(
      subTotal,
      this.getCGSTFromTotal(subTotal),
      this.getSGSTFromTotal(subTotal),
      this.getIGSTFromTotal(subTotal),
      this.getShippingCharges(subTotal)
    );
    const shippingPrice = this.getShippingCharges(subTotal);

    let editCartObj = {
      totalamount: totalAmount,
      userId,
      inshoppingcart: 1,
      orderdetails: [
        {
          id: orderDetail.id,
          quantity: tempQty,
        },
      ],
      baseprice: subTotal,
      shippingprice: shippingPrice,
      ...(isMerchantGSTEnable &&
        currentCatelogueType &&
        currentCatelogueType.registerallow !== "Catalogue_Jewellary" && {
          tax: {
            cgst: merchantInfo.CGST,
            sgst: merchantInfo.SGST,
            cgstPrice: this.getCGSTFromTotal(subTotal),
            sgstPrice: this.getSGSTFromTotal(subTotal),
          },
        }),
    };

    const editOrder = await patchCall(editCartUrl, editCartObj);
    if (editOrder.error) {
      clearLocalStorageReload({ response: editOrder });
      this.loadErrorMessageAnimation(editOrder.error.message);
      if (
        cartList &&
        cartList.error &&
        cartList.error.statusCode &&
        cartList.error.statusCode === 401
      ) {
        this.removeUserDetailAndRedirectToLogin();
        return;
      }
      this.initCartList();
    } else {
      if (isInquiry) {
        this.loadSuccessMessageAnimation(
          getValueFromLanguageObject("msg_your_inquiry_updated_successfully")
            ? getValueFromLanguageObject(
                "msg_your_inquiry_updated_successfully"
              )
            : "Your inquiry updated successfully"
        );
      } else {
        this.loadSuccessMessageAnimation(
          getValueFromLanguageObject("msg_your_order_updated_successfully")
            ? getValueFromLanguageObject("msg_your_order_updated_successfully")
            : "Your order updated successfully"
        );
      }
      this.setState({ isLoading: true });
      this.initCartList().then(() => {
        this.setState({ isLoading: false });
      });
    }
  };

  isProductOutOfStock = (orderDetail) => {
    if (!orderDetail || !orderDetail.products) return false;
    const p = orderDetail.products;

    // Pick the first defined (not null/undefined) stock-like field.
    const candidates = [
      p.availablequantity,
      p.availableQuantity,
      p.quantityavailable,
      p.stock,
      p.quantity,
    ];
    let available = undefined;
    for (let i = 0; i < candidates.length; i++) {
      const v = candidates[i];
      if (v !== undefined && v !== null) {
        available = v;
        break;
      }
    }
    if (available === undefined || available === null) return false;
    return Number(available) <= 0;
  };

  isProductInactive = (orderDetail) => {
    if (!orderDetail || !orderDetail.products) return false;
    return Number(orderDetail.products.productstatus) === 0;
  };

  getTotalofCart(cartList) {
    let total = 0;
    if (cartList && Array.isArray(cartList) && cartList.length > 0) {
      cartList.forEach(cartItem => {
        if (cartItem && cartItem.orderdetails && Array.isArray(cartItem.orderdetails)) {
          for (let i = 0; i < cartItem.orderdetails.length; i++) {
            const orderDetail = cartItem.orderdetails[i];
            if (orderDetail && orderDetail.amount && orderDetail.quantity) {
              total = total + (orderDetail.amount * orderDetail.quantity);
            }
          }
        }
      });
    }
    return total;
  }

  getShippingPriceFromCart() {
    const { cartList } = this.state;
    let total = 0;
    if (cartList && Array.isArray(cartList) && cartList.length > 0) {
      for (let i = 0; i < cartList.length; i++) {
        if (cartList[i] && cartList[i].shippingprice) {
          total = cartList[i].shippingprice;
        }
      }
    }
    return total;
  }

  initMerchantInfo = async () => {
    const { masterDetailsObj } = this.state;
    const merchantInfoUrl = getMerchantInformationUrl(masterDetailsObj);
    const merchantInfo = await getCall(merchantInfoUrl, []);
    if (merchantInfo.error) {
      clearLocalStorageReload({ response: merchantInfo });
      this.setState({
        isMerchantGSTEnable: false,
        merchantInfo: {},
        AppTitle: "",
      });
    } else {
      this.setState({
        merchantInfo,
        AppTitle: merchantInfo.companyname,
        isMerchantGSTEnable: merchantInfo.enablegst === 0 ? false : true,
      });
    }
  };

  initCatelogueSettings = async () => {
    const { masterDetailsObj } = this.state;
    const settingUrl = getSettingUrl(masterDetailsObj);
    const settingInfo = await getCall(settingUrl, []);
    if (settingInfo.error) {
      clearLocalStorageReload({ response: settingInfo });
    } else {
      let settings = {};
      settingInfo.forEach((setting) => {
        if (
          (setting.registerallow === "Catalogue_FMCG" ||
            setting.registerallow === "Catalogue_Jewellary" ||
            setting.registerallow === "Catalogue_Electronics" ||
            setting.registerallow === "Catalogue_FABRIC") &&
          setting.status === 1
        ) {
          settings = setting;
        }
      });
      this.setState({ currentCatelogueType: settings });
    }
  };

  getCGSTFromTotal = (total) => {
    const { merchantInfo } = this.state;
    return (total * merchantInfo.CGST) / 100;
  };
  getSGSTFromTotal = (total) => {
    const { merchantInfo } = this.state;
    return (total * merchantInfo.SGST) / 100;
  };

  getIGSTFromTotal = (total) => {
    const { merchantInfo } = this.state;
    return (total * merchantInfo.IGST) / 100;
  };

  getSubTotalFromTotalandServiceCharges = () => {
    const { orderDetails, serviceCharges } = this.state || {};
    let subTotal = 0;
    
    // Calculate total from orderDetails directly
    if (orderDetails && Array.isArray(orderDetails)) {
      orderDetails.forEach(orderDetail => {
        if (orderDetail && orderDetail.amount && orderDetail.quantity) {
          subTotal = subTotal + (orderDetail.amount * orderDetail.quantity);
        }
      });
    }
    
    const serviceChargeAmount = this.getServiceChargesBasedOnTotalAmount();
    subTotal = subTotal + serviceChargeAmount;
    return subTotal;
  };

  getGrandTotal = (total, cgst, sgst, igst, shippingCharge) => {
    const { merchantInfo, currentCatelogueType } = this.state;
    var grandTotal = 0;
    if (merchantInfo.enablegst === 0) {
      grandTotal = total + shippingCharge;
      return grandTotal;
    }

    if (
      merchantInfo.enablegst === 1 &&
      currentCatelogueType &&
      currentCatelogueType.registerallow === "Catalogue_Jewellary"
    ) {
      grandTotal = total + shippingCharge;
      return grandTotal;
    }

    if (merchantInfo.countryname === "India") {
      grandTotal = total + cgst + sgst + shippingCharge;
    } else {
      grandTotal = total + igst + shippingCharge;
    }
    return grandTotal;
  };

  getShippingCharges = (total) => {
    const { shippingCharges, isPincodeDeliveryEnable } = this.state;
    var charge = 0;
    if (isPincodeDeliveryEnable) {
      return this.getShippingPriceFromCart();
    }
    if (shippingCharges && Array.isArray(shippingCharges) && shippingCharges.length > 0) {
      for (let index = 0; index < shippingCharges.length; index++) {
        const shippingCharge = shippingCharges[index];
        if (
          shippingCharge &&
          shippingCharge.id === 3 &&
          shippingCharge.status === 1 &&
          shippingCharge.options &&
          Array.isArray(shippingCharge.options)
        ) {
          for (
            let jindex = 0;
            jindex < shippingCharge.options.length;
            jindex++
          ) {
            const option = shippingCharge.options[jindex];
            if (option) {
              if (
                !option.maxCondition &&
                option.minValue <= total &&
                option.maxValue >= total
              ) {
                charge = option.charges;
                break;
              }
              if (
                option.maxCondition &&
                option.minValue <= total
              ) {
                charge = option.charges;
                break;
              }
            }
          }
        }
      }
    }
    return charge;
  };

  removeProductFromCart = async (orderDetail, index) => {
    const {
      orderDetails,
      merchantInfo,
      isMerchantGSTEnable,
      currentCatelogueType,
    } = this.state;

    let userDetails = loadUserDetailsFromLocalStorage();
    if (!isOpenStoreIdExist() && userDetails === undefined) {
      return;
    } else {
      userDetails = userDetails === undefined ? {} : userDetails;
    }
    const { id } = userDetails;
    const openStoreId = getOpenStoreIdApp();
    let userId = openStoreId ? openStoreId : id;

    const tempAmount = orderDetail.amount * orderDetail.quantity;
    
    // Use the current total (including the item being removed)
    const currentTotal = this.getSubTotalFromTotalandServiceCharges();
    
    // Find the cart item that contains this order detail
    let targetCartItem = null;
    const { cartList } = this.state;
    if (cartList && Array.isArray(cartList) && cartList.length > 0) {
      for (let i = 0; i < cartList.length; i++) {
        const cartItem = cartList[i];
        if (cartItem && cartItem.orderdetails && Array.isArray(cartItem.orderdetails)) {
          const foundIndex = cartItem.orderdetails.findIndex(od => od.id === orderDetail.id);
          if (foundIndex !== -1) {
            targetCartItem = cartItem;
            break;
          }
        }
      }
    }
    
    if (!targetCartItem || !targetCartItem.id) {
      this.loadErrorMessageAnimation("Cart item not found");
      return;
    }
    
    const orderId = targetCartItem.id;
    const removeProductFromCartUrl = "orders/" + orderId;
    var removeProductFromCartObj = {};
    
    if (
      isMerchantGSTEnable &&
      currentCatelogueType &&
      currentCatelogueType.registerallow !== "Catalogue_Jewellary"
    ) {
      removeProductFromCartObj = {
        totalamount: this.getGrandTotal(
          currentTotal,
          this.getCGSTFromTotal(currentTotal),
          this.getSGSTFromTotal(currentTotal),
          this.getIGSTFromTotal(currentTotal),
          this.getShippingCharges(currentTotal)
        ),
        userId,
        inshoppingcart: 1,
        orderdetails: [
          {
            id: orderDetail.id,
            deletedAt: new Date(),
          },
        ],
        tax: {
          cgst: merchantInfo.CGST,
          sgst: merchantInfo.SGST,
          cgstPrice: this.getCGSTFromTotal(currentTotal),
          sgstPrice: this.getSGSTFromTotal(currentTotal),
        },
        baseprice: currentTotal - this.getServiceChargesBasedOnTotalAmount(),
        shippingprice: this.getShippingCharges(currentTotal),
      };
    } else if (
      isMerchantGSTEnable &&
      currentCatelogueType &&
      currentCatelogueType.registerallow === "Catalogue_Jewellary"
    ) {
      removeProductFromCartObj = {
        totalamount: this.getGrandTotal(
          currentTotal,
          this.getCGSTFromTotal(currentTotal),
          this.getSGSTFromTotal(currentTotal),
          this.getIGSTFromTotal(currentTotal),
          this.getShippingCharges(currentTotal)
        ),
        userId,
        inshoppingcart: 1,
        orderdetails: [
          {
            id: orderDetail.id,
            deletedAt: new Date(),
          },
        ],
        baseprice: currentTotal - this.getServiceChargesBasedOnTotalAmount(),
        shippingprice: this.getShippingCharges(currentTotal),
      };
    } else {
      removeProductFromCartObj = {
        totalamount: this.getGrandTotal(
          currentTotal,
          this.getCGSTFromTotal(currentTotal),
          this.getSGSTFromTotal(currentTotal),
          this.getIGSTFromTotal(currentTotal),
          this.getShippingCharges(currentTotal)
        ),
        userId,
        inshoppingcart: 1,
        orderdetails: [
          {
            id: orderDetail.id,
            deletedAt: new Date(),
          },
        ],
        shippingprice: this.getShippingCharges(currentTotal),
      };
    }

    const removeProduct = await patchCall(
      removeProductFromCartUrl,
      removeProductFromCartObj
    );
    if (removeProduct.error) {
      clearLocalStorageReload({ response: removeProduct });
      this.loadErrorMessageAnimation(removeProduct.error.message);
      if (
        cartList &&
        cartList.error &&
        cartList.error.statusCode &&
        cartList.error.statusCode === 401
      ) {
        this.removeUserDetailAndRedirectToLogin();
        return;
      }
    } else {
      this.loadSuccessMessageAnimation(
        getValueFromLanguageObject("str_product_has_been_removed_successfully")
          ? getValueFromLanguageObject(
              "str_product_has_been_removed_successfully"
            )
          : "Product has been removed successfully!"
      );
      
      // Add a small delay to ensure backend has finished processing the removal
      setTimeout(async () => {
        await this.props.counter();
        await this.fetchHeaderCounters(); // <-- add this
      }, 500);
      
      this.setState({ isLoading: true }, () => {
        this.initCartList().then(() => {
          this.setState({ isLoading: false });
          
        });
      });
    }
  };

  initPincodeDelivery = async () => {
    const { masterDetailsObj } = this.state;

    let userDetails = loadUserDetailsFromLocalStorage();
    if (!isOpenStoreIdExist() && userDetails === undefined) {
      return;
    }

    const pincodeDelivery = await getCall(
      getPincodeDeliveryUrl(masterDetailsObj),
      []
    );
    if (pincodeDelivery.error) {
      clearLocalStorageReload({ response: pincodeDelivery });
      this.loadErrorMessageAnimation(pincodeDelivery.error.message);
    } else {
      if (pincodeDelivery.length > 0) {
        const status = pincodeDelivery[0].status;
        this.setState({ isPincodeDeliveryEnable: status === 1 ? true : false });
      }
    }
  };

  onClickOfCloseIcon = (orderDetail, index) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        const submitClick = (props) => {
          this.setState({ isLoading: true }, () => {
            this.removeProductFromCart(orderDetail, index).then(() => {
              this.setState({ isLoading: false });
            });
            onClose();
          });
        };
        return (
          <>
            <ConfirmAlertPopup
              title={
                getValueFromLanguageObject("str_title_remove_product")
                  ? getValueFromLanguageObject("str_title_remove_product")
                  : "Remove Product"
              }
              message={
                getValueFromLanguageObject("str_remove_product_cart")
                  ? getValueFromLanguageObject("str_remove_product_cart")
                  : "Are you sure you want to remove this product?"
              }
              animation={<DeleteAnim />}
              submit={
                getValueFromLanguageObject("str_yes_remove_it")
                  ? getValueFromLanguageObject("str_yes_remove_it")
                  : "Yes, Remove it!"
              }
              submitClick={submitClick}
              cancelClick={onClose}
              cancel={
                getValueFromLanguageObject("str_no")
                  ? getValueFromLanguageObject("str_no")
                  : "No"
              }
            />
          </>
        );
      },
    });
  };

  loadErrorMessageAnimation = (message) => {
    this.setState({ errorMessage: message, showErrorMessageModal: true });
  };

  loadSuccessMessageAnimation = (message) => {
    this.setState({ successMessage: message, showSuccessMessageModal: true });
  };

  renderServiceChargesLable = (serviceCharges) => {
    const { status, text = "" } = serviceCharges || {};
    if (status === 1) {
      const serviceChargeList = JSON.parse(text) || {};
      if (serviceChargeList) {
        const [labelObj] = serviceChargeList.filter((sc) => sc.key === "label");
        return labelObj.value;
      }
    }
    return "";
  };

  getServiceChargesBasedOnTotalAmount = () => {
    const { orderDetails, serviceCharges } = this.state || [];
    const { status, text } = serviceCharges || {};
    let serviceChargesAmount = 0;

    if (status === 1) {
      const serviceChargeList = JSON.parse(text) || {};
      if (serviceChargeList) {
        const [isPercentageObj] = serviceChargeList.filter(
          (sc) => sc.key === "isPercentage"
        );
        const [percentageObj] = serviceChargeList.filter(
          (sc) => sc.key === "percentage"
        );
        const [amountObj] = serviceChargeList.filter(
          (sc) => sc.key === "amount"
        );
        if (isPercentageObj && isPercentageObj.value) {
          // Calculate total from orderDetails directly
          let totalAmount = 0;
          if (orderDetails && Array.isArray(orderDetails)) {
            orderDetails.forEach(orderDetail => {
              if (orderDetail && orderDetail.amount && orderDetail.quantity) {
                totalAmount = totalAmount + (orderDetail.amount * orderDetail.quantity);
              }
            });
          }
          serviceChargesAmount = (totalAmount * percentageObj.value) / 100;
        }
        if (isPercentageObj && !isPercentageObj.value) {
          serviceChargesAmount = parseFloat(amountObj.value);
        }
      }
    }
    return serviceChargesAmount;
  };

  getServiceChargesForAmount = (amount) => {
    const { serviceCharges } = this.state || [];
    const { status, text } = serviceCharges || {};
    let serviceChargesAmount = 0;

    if (status === 1) {
      const serviceChargeList = JSON.parse(text) || {};
      if (serviceChargeList) {
        const [isPercentageObj] = serviceChargeList.filter(
          (sc) => sc.key === "isPercentage"
        );
        const [percentageObj] = serviceChargeList.filter(
          (sc) => sc.key === "percentage"
        );
        const [amountObj] = serviceChargeList.filter(
          (sc) => sc.key === "amount"
        );
        if (isPercentageObj && isPercentageObj.value) {
          serviceChargesAmount = (amount * percentageObj.value) / 100;
        }
        if (isPercentageObj && !isPercentageObj.value) {
          serviceChargesAmount = parseFloat(amountObj.value);
        }
      }
    }
    return serviceChargesAmount;
  };

  render() {
    const { symbol, isInquiry } = this.props;
    const {
      orderDetails,
      cartList,
      isLoading,
      isMerchantGSTEnable,
      AppTitle,
      currentCatelogueType,
      showErrorMessageModal,
      errorMessage,
      showSuccessMessageModal,
      successMessage,
      masterDetailsObj,
      isFullScreenImage,
      fullScreenImagePath,
      serviceCharges,
      outOfStockProductIds, // NEW
    } = this.state;

    const strbackToShopping = getValueFromLanguageObject("str_back_to_shopping")
      ? getValueFromLanguageObject("str_back_to_shopping")
      : "back to shopping";

    const strContinueToPay = getValueFromLanguageObject("str_continue_to_pay")
      ? getValueFromLanguageObject("str_continue_to_pay")
      : "continue to pay";

    const subTotal = this.getSubTotalFromTotalandServiceCharges();

    const hasZeroQtyProduct = orderDetails.some(od => Number(od.quantity) === 0);
    const { inactiveProductIds = [] } = this.state;
const hasInactiveProduct = inactiveProductIds.length > 0;
const disableCheckout = outOfStockProductIds.length > 0 || hasZeroQtyProduct || hasInactiveProduct;

    return (
      <div>
        {/*SEO Support*/}
        <Helmet>
          <title>
            {AppTitle} |{" "}
            {getValueFromLanguageObject("str_cart_list_page")
              ? getValueFromLanguageObject("str_cart_list_page")
              : "Cart List Page"}
          </title>
          <meta
            name="description"
            content="Multikart – Multipurpose eCommerce React Template is a multi-use React template. It is designed to go well with multi-purpose websites. Multikart Bootstrap 4 Template will help you run multiple businesses."
          />
        </Helmet>
        {/*SEO Support End */}

        <Breadcrumb
          title={
            getValueFromLanguageObject("cart_page")
              ? getValueFromLanguageObject("cart_page")
              : "Cart Page"
          }
        />

        {(orderDetails && Array.isArray(orderDetails) && orderDetails.length > 0) ? (
          <section className="cart-section section-b-space custom-cart">
            <div className="container">

              {/* NEW: Banner if any out-of-stock */}
              {outOfStockProductIds.length > 0 && (
                <div className="alert alert-warning py-2">
                  {getValueFromLanguageObject("str_some_products_out_of_stock")
                    ? getValueFromLanguageObject("str_some_products_out_of_stock")
                    : "Some products are out of stock. Please remove them to proceed."}
                </div>
              )}

              {/* NEW: Banner if any inactive */}
              {hasInactiveProduct && (
  <div className="alert alert-warning py-2">
    {getValueFromLanguageObject("str_some_products_inactive")
      ? getValueFromLanguageObject("str_some_products_inactive")
      : "Some products are inactive. Please remove them to proceed."}
  </div>
)}

              <div className="row">
                <div className="col-sm-12">
                  <table className="table cart-table table-responsive-xs">
                    <thead>
                      <tr className="table-head">
                        <th scope="col" className="pb-1 pt-1">
                          {getValueFromLanguageObject("str_image")
                            ? getValueFromLanguageObject("str_image")
                            : "image"}
                        </th>
                        <th scope="col" className="pb-1 pt-1">
                          {getValueFromLanguageObject("str_product_name")
                            ? getValueFromLanguageObject("str_product_name")
                            : "product name"}
                        </th>

                        {!isInquiry && (
                          <th scope="col" className="pb-1 pt-1">
                            {getValueFromLanguageObject("str_price")
                              ? getValueFromLanguageObject("str_price")
                              : "price"}
                          </th>
                        )}
                        <th scope="col" className="pb-1 pt-1">
                          {getValueFromLanguageObject("str_quantity")
                            ? getValueFromLanguageObject("str_quantity")
                            : "quantity"}
                        </th>
                        <th scope="col" className="pb-1 pt-1">
                          {getValueFromLanguageObject("str_action")
                            ? getValueFromLanguageObject("str_action")
                            : "action"}
                        </th>
                        {!isInquiry && (
                          <th scope="col" className="pb-1 pt-1">
                            {getValueFromLanguageObject("str_total")
                              ? getValueFromLanguageObject("str_total")
                              : "total"}
                          </th>
                        )}
                      </tr>
                    </thead>
                    {orderDetails.map((item, index) => {
                      const outOfStock = this.isProductOutOfStock(item);
                      const inactive = this.isProductInactive(item);
                      return (
                        <tbody key={index} className={outOfStock || inactive ? "out-of-stock-row" : ""}>
                          <tr>
                            <td
                              style={outOfStock ? { opacity: 0.6 } : {}}
                              onClick={() => {
                                const path =
                                  item && item.products && item.products.productmedia && Array.isArray(item.products.productmedia) && item.products.productmedia.length > 0
                                    ? getImageUrl(
                                        item.products.productmedia[0]
                                          .productname,
                                        masterDetailsObj
                                      )
                                    : getPlaceHolderImage();
                                this.setState({
                                  isFullScreenImage: true,
                                  fullScreenImagePath: path,
                                });
                              }}
                            >
                              <img
                                className="view-image"
                                src={
                                  item && item.products && item.products.productmedia && Array.isArray(item.products.productmedia) && item.products.productmedia.length > 0
                                    ? getImageUrl(
                                        item.products.productmedia[0]
                                          .productname,
                                        masterDetailsObj
                                      )
                                    : getPlaceHolderImage()
                                }
                                alt=""
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = getPlaceHolderImage();
                                }}
                              />
                            </td>
                            <td>
                              <Link to={`/singleproduct/${item && item.products ? item.products.id : ''}`}>
                                {item && item.products ? item.products.name : ''}
                              </Link>
                              {outOfStock && (
                                <div className="text-danger small mt-1">
                                  {getValueFromLanguageObject("str_out_of_stock_remove")
                                    ? getValueFromLanguageObject("str_out_of_stock_remove")
                                    : "Out of stock - please remove this product."}
                                </div>
                              )}
                              {inactive && (
                                <div className="text-danger small mt-1">
                                 Product is inactive - please remove this product.
                                </div>
                              )}
                            </td>
                            {!isInquiry && (
                              <td>
                                <b className={outOfStock ? "text-muted" : ""}>
                                  {formatPrice(item && item.amount ? item.amount : 0)}
                                </b>
                              </td>
                            )}

                            <td>
                              <div className="qty-box">
                                <div className="input-group">
                                  <span className="input-group-prepend">
                                    <button
                                      type="button"
                                      className="btn quantity-left-minus"
                                      onClick={() => !(outOfStock || inactive) && this.minusQty(item, index)}
                                      disabled={outOfStock || inactive}
                                    >
                                      <i className="fa fa-angle-left" />
                                    </button>
                                  </span>
                                  <input
                                    type="number"
                                    name="quantity"
                                    value={item && item.quantity ? item.quantity : 0}
                                    min="1"
                                    onChange={(e) => {
                                      let val = e.target.value.replace(/[^0-9]/g, "");
                                      if (val === "") val = "1";
                                      // Remove logic that caps at available quantity
                                      if (!(outOfStock || inactive)) this.changeQty(index, { target: { value: val } });
                                    }}
                                    onPaste={(e) => {
                                      const paste = e.clipboardData.getData('text');
                                      if (!/^\d+$/.test(paste)) e.preventDefault();
                                    }}
                                    onBlur={() => {
                                      if (!(outOfStock || inactive)) this.updateCartAPI(item, index);
                                    }}
                                    className="form-control input-number"
                                    disabled={outOfStock || inactive}
                                    style={outOfStock || inactive ? { backgroundColor: "#f5f5f5" } : {}}
                                  />
                                  <span className="input-group-prepend">
                                    <button
                                      className="btn quantity-right-plus"
                                      onClick={() => !(outOfStock || inactive) && this.plusQty(item, index)}
                                      disabled={outOfStock || inactive}
                                    >
                                      <i className="fa fa-angle-right" />
                                    </button>
                                  </span>
                                </div>
                                {/* Remove this block that shows available quantity to user */}
                                {/* 
                                <div className="text-muted small mt-1">
                                  {getValueFromLanguageObject("str_available_quantity")
                                    ? getValueFromLanguageObject("str_available_quantity")
                                    : "Available"}: {this.getAvailableQuantity(item)}
                                </div>
                                */}
                              </div>
                            </td>
                            <td>
                              <div
                                className="icon"
                                onClick={() => {
                                  this.onClickOfCloseIcon(item, index);
                                }}
                              >
                                <i className="fa fa-trash" />
                              </div>
                            </td>

                            {!isInquiry && (
                              <td>
                                <b className={outOfStock ? "text-muted" : "td-color"}>
                                  {formatPrice(
                                    (item && item.quantity ? item.quantity : 0) *
                                      (item && item.amount ? item.amount : 0)
                                  )}
                                </b>
                              </td>
                            )}
                          </tr>
                        </tbody>
                      );
                    })}
                  </table>
                  <div class="row">
                    <div class="col-md-6" />
                    <div class="col-md-6">
                      {!isInquiry && (
                        <div class="cart-total">
                          <table className="table cart-table table-responsive-md">
                            <tfoot className="default-padding__cart__edit__order">
                              <tr>
                                <td>
                                  {getValueFromLanguageObject(
                                    "str_total_price_with_colun"
                                  )
                                    ? getValueFromLanguageObject(
                                        "str_total_price_with_colun"
                                      )
                                    : "Total Price :"}
                                </td>
                                <td>
                                  <b>
                                    {formatPrice(this.getSubTotalFromTotalandServiceCharges() - this.getServiceChargesBasedOnTotalAmount())}
                                  </b>
                                </td>
                              </tr>

                              {serviceCharges && serviceCharges.status === 1 && (
                                <tr>
                                  <td>
                                    {`+ ${this.renderServiceChargesLable(
                                      serviceCharges
                                    )}`}
                                  </td>

                                  <td>
                                    <b>
                                      {formatPrice(
                                        this.getServiceChargesBasedOnTotalAmount()
                                      )}
                                    </b>
                                  </td>
                                </tr>
                              )}

                              {/*
                              <tr>
                                <td>
                                  {"+ "}
                                  {getValueFromLanguageObject(
                                    "shipping_charges_with_colun"
                                  )
                                    ? getValueFromLanguageObject(
                                        "shipping_charges_with_colun"
                                      )
                                    : "Shipping Charges : "}
                                </td>
                                <td>
                                  <b>
                                    {formatPrice(this.getShippingCharges(subTotal))}
                                  </b>
                                </td>
                              </tr>
                              */}

                              {isMerchantGSTEnable &&
                                currentCatelogueType &&
                                currentCatelogueType.registerallow !==
                                  "Catalogue_Jewellary" &&
                                this.state.merchantInfo.countryname ===
                                  "India" && (
                                  <tr>
                                    <td>
                                      {`+ ${
                                        getValueFromLanguageObject("str_cgst")
                                          ? getValueFromLanguageObject(
                                              "str_cgst"
                                            )
                                          : "CGST"
                                      } (${this.state.merchantInfo.CGST}%) :`}
                                    </td>
                                    <td>
                                      <b>
                                        {formatPrice(
                                          this.getCGSTFromTotal(subTotal)
                                        )}
                                      </b>
                                    </td>
                                  </tr>
                                )}
                              {isMerchantGSTEnable &&
                                currentCatelogueType &&
                                currentCatelogueType.registerallow !==
                                  "Catalogue_Jewellary" &&
                                this.state.merchantInfo.countryname ===
                                  "India" && (
                                  <tr>
                                    <td>
                                      {`+ ${
                                        getValueFromLanguageObject("str_sgst")
                                          ? getValueFromLanguageObject(
                                              "str_sgst"
                                            )
                                          : "SGST"
                                      } (${this.state.merchantInfo.SGST}%) : `}
                                    </td>
                                    <td>
                                      <b>
                                        {formatPrice(
                                          this.getSGSTFromTotal(subTotal)
                                        )}
                                      </b>
                                    </td>
                                  </tr>
                                )}
                              {isMerchantGSTEnable &&
                                currentCatelogueType &&
                                currentCatelogueType.registerallow !==
                                  "Catalogue_Jewellary" &&
                                this.state.merchantInfo.countryname !==
                                  "India" && (
                                  <tr>
                                    <td>
                                      {`+ ${
                                        getValueFromLanguageObject("str_igst")
                                          ? getValueFromLanguageObject(
                                              "str_igst"
                                            )
                                          : "IGST "
                                      } (${this.state.merchantInfo.IGST}%) : `}
                                    </td>
                                    <td>
                                      <b>
                                        {formatPrice(
                                          this.getIGSTFromTotal(subTotal)
                                        )}
                                      </b>
                                    </td>
                                  </tr>
                                )}
                              {/*
                              <tr>
                                <td>
                                  {`- ${
                                    getValueFromLanguageObject(
                                      "discount_with_colun"
                                    )
                                      ? getValueFromLanguageObject(
                                          "discount_with_colun"
                                        )
                                      : "Discount :"
                                  }`}
                                </td>
                                <td>
                                  <b>
                                    {formatPrice(0)}
                                  </b>
                                </td>
                              </tr>
                              */}

                              <tr className="order_total">
                                <td>
                                  {getValueFromLanguageObject(
                                    "str_amount_payable_with_colun"
                                  )
                                    ? getValueFromLanguageObject(
                                        "str_amount_payable_with_colun"
                                      )
                                    : "Amount Payable :"}
                                </td>
                                <td>
                                  <b>
                                    {formatPrice(
                                      this.getGrandTotal(
                                        subTotal,
                                        this.getCGSTFromTotal(subTotal),
                                        this.getSGSTFromTotal(subTotal),
                                        this.getIGSTFromTotal(subTotal),
                                        this.getShippingCharges(subTotal)
                                      )
                                    )}
                                  </b>
                                </td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row cart-buttons">
                <div className="col-sm-6">
                  <Link to={`/products`} className="btn btn-solid">
                    {strbackToShopping}
                  </Link>
                </div>
                <div className="col-sm-6">
                  <Link
                    to={disableCheckout ? "#" : `/checkout`}
                    className={`btn btn-solid ${disableCheckout ? "disabled" : ""}`}
                    onClick={(e) => {
                      if (disableCheckout) e.preventDefault();
                    }}
                    title={
                      disableCheckout
                        ? (getValueFromLanguageObject("str_remove_out_of_stock_first")
                            ? getValueFromLanguageObject("str_remove_out_of_stock_first")
                            : "Remove out-of-stock or zero quantity products first")
                        : ""
                    }
                  >
                    {strContinueToPay}
                  </Link>
                </div>
              </div>
            </div>
          </section>
        ) : (
          <NoProductFoundCartAnim />
        )}
        {isLoading && <MainLoader />}
        {showErrorMessageModal && (
          <ErrorMessageAnimationModal
            show={showErrorMessageModal}
            message={errorMessage}
            onClose={() => {
              this.setState({ showErrorMessageModal: false });
            }}
          />
        )}
        {showSuccessMessageModal && (
          <SuccessMessageAnimationModal
            show={showSuccessMessageModal}
            message={successMessage}
            onClose={() => {
              this.setState({ showSuccessMessageModal: false });
            }}
          />
        )}
        {isFullScreenImage && (
          <Lightbox
            mainSrc={fullScreenImagePath}
            onCloseRequest={() =>
              this.setState({
                isFullScreenImage: false,
                fullScreenImagePath: "",
              })
            }
          />
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  symbol: getCurrencySymbol(),
  isInquiry: state.settings.isInquiry,
});

export default connect(
  mapStateToProps,
  {
    counter: getCommonCounter,
    notificationCounter: getNotificationCounter,
    isInquiryOrCart: isInquiryOrCart,
    updateQuantity: getUpdateQuantity,
    setHeaderCounters,
  }
)(withRouter(cartComponent));
